import {atom, useAtom, useSetAtom} from 'jotai';
import {useLocation, useNavigate} from 'react-router-dom';
import {paths} from '@/router';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {Button} from '../Button';
import {Modal} from '../Modal';
import {Typography} from '../Typography';

export enum SessionErrorType {
  duplicated = 'duplicated', // 동시 로그인
  invalid = 'invalid', // 세션 강제 종료
}

const hasSessionError = atom<{
  hasError: boolean;
  type?: SessionErrorType;
  from?: {pathname: string; search: string};
}>({hasError: false});

const CONTENT = {
  [SessionErrorType.duplicated]: {
    title: '동시 로그인',
    desc: '다른 기기에서 접속이 감지되어 로그아웃되었습니다. 다시 로그인해 주시기 바랍니다.',
  },
  [SessionErrorType.invalid]: {
    title: '자동 로그아웃',
    desc: '다른 기기에서 계정 정보가 변경되어 로그아웃되었습니다. 다시 로그인해 주시기 바랍니다.',
  },
};

export const useSessionErrorModal = () => {
  const setModal = useSetAtom(hasSessionError);

  return (type: SessionErrorType) => {
    setModal({
      hasError: true,
      type,
    });
  };
};

export const SessionErrorModalSystem = () => {
  const [activeModal, setModal] = useAtom(hasSessionError);
  const navigate = useNavigate();
  const {pathname, search} = useLocation();

  const onClick = () => {
    navigate({pathname: paths.signin}, {state: {from: {pathname, search}}});
    setModal({
      hasError: false,
    });
  };

  if (!activeModal?.hasError) {
    return null;
  }

  const content = activeModal?.type && CONTENT[activeModal.type];

  return (
    <Modal title={content?.title} width={328} onClose={onClick}>
      <PaddingBox spacing={24}>
        <Typography variant="medium14" color={palette.gray600}>
          {content?.desc}
        </Typography>
        <PaddingBox top={24}>
          <Button fullWidth color="secondary" onClick={onClick}>
            로그인
          </Button>
        </PaddingBox>
      </PaddingBox>
    </Modal>
  );
};
